import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "userLogin",
      component: () => import("@/views/userLogin"),
    },
    // {
    //   path: '/home',
    //   name: 'home',
    //   component: () => import('@/views/home'),
    // },
    {
      path: "/personalCenter/personCenter",
      name: "/personCenter",
      component: () => import("@/views/personalCenter/personCenter"),
    },
    {
      path: "/userRegister",
      name: "/userRegister",
      component: () => import("@/views/userRegister"),
    },
    {
      path: "/login/appMessage",
      name: "/appMessage",
      component: () => import("@/views/login/appMessage"),
    },
    {
      path: "/login/examMessage",
      name: "/examMessage",
      component: () => import("@/views/login/examMessage"),
    },
    {
      path: "/reviewExperts/viewInfo",
      name: "/viewInfo",
      component: () => import("@/views/reviewExperts/viewInfo"),
    },
    {
      path: "/projectListView/applicationList",
      name: "/applicationList",
      component: () => import("@/views/projectListView/applicationList"),
    },
    {
      path: "/administrators/auditItems",
      name: "/auditItems",
      component: () => import("@/views/administrators/auditItems"),
    },
    {
      path: "/administrators/userList",
      name: "/userList",
      component: () => import("@/views/administrators/userList"),
    },
    {
      path: "/administrators/projectItems",
      name: "/projectItems",
      component: () => import("@/views/administrators/projectItems"),
    },
    {
      path: "/applicationFilling/myApplication",
      name: "/myApplication",
      component: () => import("@/views/applicationFilling/myApplication"),
    },
    {
      path: "/login/applicationIndex",
      name: "/applicationIndex",
      component: () => import("@/views/login/applicationIndex"),
    },
    {
      path: "/login/reviewList",
      name: "/reviewList",
      component: () => import("@/views/login/reviewList"),
    },
    {
      path: "/login/managerAll",
      name: "/managerAll",
      component: () => import("@/views/login/managerAll"),
    },
  ],
});
router.beforeEach((to, from, next) => {
  const getUserRoleFromStore = () => {
    // 获取角色数组
    // return JSON.parse(localStorage.getItem("userRoles") || "[]");
    return JSON.parse(localStorage.getItem("userInfo") || "[]"); // 从 localStorage 中获取用户角色信息
  };
  const userInfo = getUserRoleFromStore();
  // if (to.path === "/login/applicationIndex" && !userInfo.includes(2)) {
  //   next({ path: "/login/reviewList" });
  // } else if (to.path === "/login/reviewList" && !userInfo.includes(5)) {
  //   next({ path: "/login/managerAll" });
  // }

  if (to.path === "/login/applicationIndex" && !userInfo.includes(2)) {
    // 申请人才能访问的路由
    if (userInfo.includes(5)) {
      next({ path: "/login/reviewList" });
    } else {
      next({ path: "/login/managerAll" });
    }
  } else if (to.path === "/login/reviewList" && !userInfo.includes(5)) {
    // 评审专家才能访问的路由
    if (userInfo.includes(2)) {
      next({ path: "/login/applicationIndex" });
    } else {
      next({ path: "/login/managerAll" });
    }
  } else {
    next();
  }
});
export default router;
